import { Box, Text, type TextProps } from '@shopify/polaris';
import type { GTooltipProps } from '../GTooltip';

import { GTooltip } from '../GTooltip';

export interface GTextTooltipProps extends TextProps {
  tooltipProps?: GTooltipProps;
}

export const GTextTooltip = ({ tooltipProps, ...textProps }: GTextTooltipProps) => {
  return (
    <GTooltip {...tooltipProps}>
      <Box borderBlockEndWidth="025" borderStyle="dashed" borderColor="border-tertiary">
        <Text {...textProps}></Text>
      </Box>
    </GTooltip>
  );
};
